// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2snf9","buttons":"Footer_buttons__3VY5L"};